

import axios from 'src/utils/axios';
import { paths } from 'src/routes/paths';

// Decode JWT token
function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
}

// Check if token is valid
export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  return decoded;
};

export const setSession = (accessToken,user) => {

  if (accessToken && user) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('role',user.roleType)
    localStorage.setItem('user',user)
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
 
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common.Authorization;
  }
};
